import { httpRequest } from "@services/http";
import { SpendAccount } from "@models/spendaccount.model";
import { SpendAccountSerializer } from "@models/serializers/spendAccountSerializer";

export class CommandGetSpendAccount {
  async run(contractId: number): Promise<SpendAccount> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/spend-account/`;
    const response = await httpRequest<any>(url, { method: "GET" });
    return SpendAccountSerializer.fromJson(response);
  }
}
